export const FETCH_UPGRADE_DETAILS = 'FETCH_UPGRADE_DETAILS'
export const FETCH_UPGRADE_DETAILS_SUCCESS = 'FETCH_UPGRADE_DETAILS_SUCCESS'
export const FETCH_UPGRADE_DETAILS_ERROR = 'FETCH_UPGRADE_DETAILS_ERROR'

export const SELECT_MEMBERSHIP = 'SELECT_MEMBERSHIP'
